export default __webpack_public_path__ + "media/shipment/zipasgo-44a6e67f.svg";